@let o = offer();
<a class="offer-item" [routerLink]="['/brands', o.brand.slug, 'offers', o.url]" draggable="false">
    <img class="offer-image" [src]="(o.card_url || o.gallery_urls?.at(0)) | bucket:true" draggabe="false" [fallback]="'images/fallback/category.webp'" [alt]="o.short_title"/>
    <div class="offer-tint">

    </div>
    <img class="offer-logo" [src]="o.brand.logo_url | bucket:true" draggable="false" [fallback] [alt]="o.brand.name"/>
    <div class="offer-tag font-bold py-4 px-8">
        <span [paint]="o.plan">{{o.tag_value}}</span>
    </div>
    <div class="offer-details">
        <p class="mt-0 mb-4 offer-brand">
            {{o.brand.title || o.brand.short || o.brand.name}}
        </p>
        <h3 class="m-0 offer-title font-bold">
            <span>{{o.short_title || 'Offer'}}</span>
        </h3>
    </div>
</a>

